import { MyIcon } from '~/components/ui/MyIcon'
import { getGpuList_itemModule_productItemPage_edges_node_ProductItem } from '~/graphqls/types'
import { FenToYuan } from '~/utils'

interface Props {
  data: getGpuList_itemModule_productItemPage_edges_node_ProductItem
  showPrice?: boolean
}

export default function GpuCard({ data, showPrice = true }: Props) {
  const desc = JSON.parse(data.desc!)
  const hourPrice = data?.skuList?.[0]

  return (
    <div className="w-full text-neutral-500 p-4">
      <div className="font-semibold text-[22px] leading-[32px]">
        {data.name}
      </div>
      {showPrice && (
        <div className="mt-2 text-sm">
          <span className="font-semibold text-lg text-primary">
            ￥{FenToYuan(hourPrice?.price)}
          </span>
          <span className=" text-neutral-900">
            /{hourPrice?.spec?.[0]?.property}{' '}
          </span>
          {hourPrice?.showPrice > hourPrice?.price && (
            <span className="line-through text-neutral-400">
              ￥{FenToYuan(hourPrice?.showPrice)}
            </span>
          )}
        </div>
      )}
      <div className="mt-2 text-xs flex items-center">
        <MyIcon icon="vc" className="mr-1 text-[16px]" />
        <span>显存 {desc['显存']}</span>
      </div>
      <div className="mt-2 text-xs flex items-center">
        <MyIcon icon="microchip" className="mr-1 text-[16px]" />
        <span>GPU {desc['GPU']}</span>
      </div>
      <div className="mt-2 text-xs flex items-center">
        <MyIcon icon="ram" className="mr-1 text-[16px]" />
        <span>内存 {desc['内存']}</span>
      </div>
      <div className="mt-2 text-xs flex items-center">
        <MyIcon icon="disk" className="mr-1 text-[16px]" />
        <span>硬盘 {desc['硬盘']}</span>
      </div>
    </div>
  )
}
